// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ESgm5","index":"styles_index__khAXx"};